import React, { useRef, useState } from 'react'
import { Modal, InputGroup, FormControl, Overlay, Tooltip } from "react-bootstrap";
import ShareIcon from '../ShareIcon';
import CopyIcon from '../../icons/copy.svg';
import UserContext from "../../UserContext";

import '../../styles/share.css';

function ShareModel(props) {
  const [showTooltip, setshowTooltip] = useState(false);
  const target = useRef(null);

  const { mode } = React.useContext(UserContext);
  const [dark, setDark] = React.useState(false);

  React.useEffect(() => {
    let darkmode = localStorage.getItem("darkmode")
      ? JSON.parse(localStorage.getItem("darkmode"))
      : false;
    setDark(darkmode);
  }, [mode]);

  return (
    <Modal
      {...props}
      size="sm"
      centered
      scrollable="false"
      className={dark && "special_modal"}
    >
      <Modal.Header closeButton >
        <Modal.Title id="contained-modal-title-vcenter">
          <span className="font-bold text-sm text-fire">Share</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="icons-container">
          <ShareIcon
            iconName="twitter"
            url={props.toCopyUrl}
            postText={props.postsText}
            dark={dark}
          />
          <ShareIcon
            iconName="facebook"
            url={props.toCopyUrl}
            postText={props.postsText}
            dark={dark}
          />
          <ShareIcon
            iconName="instagram"
            url={props.toCopyUrl}
            postText={props.postsText}
            dark={dark}
          />
          <ShareIcon
            iconName="linkedin"
            url={props.toCopyUrl}
            postText={props.postsText}
            dark={dark}
          />
        </div>
        <div className="url-container mt-3">
          <p className={"font-bold text-xs " + (dark && " text-muted ")}>Or copy link</p>
          <InputGroup className={" mb-3 " + (dark && " divbg-in-darkmode ")}>
            <FormControl
              disabled
              placeholder={props.toCopyUrl}
              aria-label=""
              aria-describedby="basic-addon2"
              className="editedInput "
            />
            <InputGroup.Text id="basic-addon2" ref={target} className="copy-icon-container"
              onClick={() => {
                navigator.clipboard.writeText(props.toCopyUrl)
                setshowTooltip(true)
                setTimeout(() => {
                  setshowTooltip(false)
                }, 1000)
              }}
            ><img alt="copy" src={CopyIcon} className="copy-svg" /></InputGroup.Text>
          </InputGroup>

          <Overlay target={target.current} show={showTooltip} placement="top">
            {(props) => (
              <Tooltip id="overlay-example" {...props}>
                Link copied!
              </Tooltip>
            )}
          </Overlay>

        </div>

      </Modal.Body>
    </Modal>
  )
}

export default ShareModel;